import '@/components/ag-grid/config/agGridModules';

import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { preloadLucideIcons, registerCustomIcons } from '@utilities-one/gpm-ui';

import { App } from '@/App';

import '@/assets/css/globals.css';

// Preload Lucide icons to avoid loading delays and UI shifts
void preloadLucideIcons();

// Register gpm-ui custom SVG icons once at startup so components can render
// them via `<Icon name="custom:..." />` (and, transitively, the sidebar's
// string-based icon prop).
void registerCustomIcons();

const apiUrl = import.meta.env.VITE_API_URL;

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({
      // Map tiles arrive as resource.img spans — hundreds per map pageload, pure noise.
      ignoreResourceSpans: ['resource.img'],
      // Skip http.client spans for tile / COG / basemap fetches.
      shouldCreateSpanForRequest: (url) =>
        !url.includes('digitaloceanspaces.com') &&
        !url.includes('basemaps.cartocdn.com') &&
        !url.includes('arcgis.com'),
    }),
    Sentry.replayIntegration(),
  ],
  tracePropagationTargets: apiUrl ? ['localhost', apiUrl] : ['localhost'],
  // 1% of traces — the sampled ones are still captured end-to-end (webapp + API).
  tracesSampleRate: 0.01,
  // Record a replay only when an error happens, not random sessions.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true,
  // Filter out third-party / browser-extension noise (e.g. injected views.js).
  ignoreErrors: ['updateFrom'],
});

// Mount application with error handling
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element. Ensure index.html contains <div id="root"></div>');
}

ReactDOM.createRoot(rootElement).render(<App />);
